import React from 'react';
import ReactDOM from 'react-dom/client';
import '@link/portal/styles/index.css';
import '@link/portal/i18n';
import App from '@link/portal/App';
import '@link/portal/vendors/sentry';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
